module.exports = __webpack_public_path__ + "39ff74a7a206fc5e30eb65eb8868374e.png";